// extracted by mini-css-extract-plugin
export default {"dataImg":"first-time-modal_dataImg__vzOIe","dataDialougeCheckBox":"first-time-modal_dataDialougeCheckBox__RuCAM","dataDialougeActions":"first-time-modal_dataDialougeActions__R67Nj"};